import request from '@/tools/request'
import { HTTP } from '../http'
import { PagiPromiseResponseData, PromiseResponseData } from '../../global'
import {
  FrontSelfContractListVO,
  FrontSelfContractAttachmentStatusVO,
} from './response'
import {
  FrontSelfContractPageParam,
  SelfContractImportFileParam,
} from './request'

const { GET, POST } = request

/**
 * SCP 自营协议管理 - 前台接口（对齐 srm-api-supplier SelfContractController，Base URL /selfContract）
 */

// 15.1 协议分页列表
export const GET_SELF_CONTRACT_PAGE = (
  params: FrontSelfContractPageParam,
): PagiPromiseResponseData<FrontSelfContractListVO[]> =>
  GET(`${HTTP}/selfContract/page`, params)

// 15.2.2 提交附件审核（body 为 /upload/uploadFiles 返回的 data[0]）
export const IMPORT_SELF_CONTRACT_FILE = (
  params: SelfContractImportFileParam,
): PromiseResponseData<boolean> =>
  POST(`${HTTP}/selfContract/importFile`, params, 'application/json')

// 15.4 下载协议文件（二进制流，后端按归档 > 待签署 > 模板 决定内容）
export const DOWNLOAD_SELF_CONTRACT_FILE = (params: { ids: string[] }) =>
  POST(`${HTTP}/selfContract/downloadContractFile`, params, 'application/json')

// 15.3 查询协议附件审核状态
export const GET_SELF_CONTRACT_ATTACHMENT_STATUS = (
  id: string,
): PromiseResponseData<FrontSelfContractAttachmentStatusVO> =>
  GET(`${HTTP}/selfContract/attachmentStatus`, { id })
import request from '@/tools/request'
import { HTTP } from '../http'
import { PagiPromiseResponseData, PromiseResponseData } from '../../global'
import {
  FrontSelfContractListVO,
  FrontSelfContractAttachmentStatusVO,
} from './response'
import {
  FrontSelfContractPageParam,
  SelfContractImportFileParam,
} from './request'

const { GET, POST } = request

/**
 * SCP 自营协议管理 - 前台接口（对齐 srm-api-supplier SelfContractController，Base URL /selfContract）
 */

// 15.1 协议分页列表
export const GET_SELF_CONTRACT_PAGE = (
  params: FrontSelfContractPageParam,
): PagiPromiseResponseData<FrontSelfContractListVO[]> =>
  GET(`${HTTP}/selfContract/page`, params)

// 15.2.2 提交附件审核（body 为 /upload/uploadFiles 返回的 data[0]）
export const IMPORT_SELF_CONTRACT_FILE = (
  params: SelfContractImportFileParam,
): PromiseResponseData<boolean> =>
  POST(`${HTTP}/selfContract/importFile`, params, 'application/json')

// 15.4 下载协议文件（二进制流，后端按归档 > 待签署 > 模板 决定内容）
export const DOWNLOAD_SELF_CONTRACT_FILE = (params: { ids: string[] }) =>
  POST(`${HTTP}/selfContract/downloadContractFile`, params, 'application/json')

// 15.3 查询协议附件审核状态
export const GET_SELF_CONTRACT_ATTACHMENT_STATUS = (
  id: string,
): PromiseResponseData<FrontSelfContractAttachmentStatusVO> =>
  GET(`${HTTP}/selfContract/attachmentStatus`, { id })
